/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Premium_Unlimited_TitleInputs */

const en_dialog_premium_unlimited_title = /** @type {(inputs: Dialog_Premium_Unlimited_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy unlimited listening`)
};

const es_dialog_premium_unlimited_title = /** @type {(inputs: Dialog_Premium_Unlimited_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disfruta escucha ilimitada`)
};

/**
* | output |
* | --- |
* | "Enjoy unlimited listening" |
*
* @param {Dialog_Premium_Unlimited_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_premium_unlimited_title = /** @type {((inputs?: Dialog_Premium_Unlimited_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Premium_Unlimited_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_premium_unlimited_title(inputs)
	return en_dialog_premium_unlimited_title(inputs)
});